import React, { useState } from "react";
import Icon from "../../../components/AppIcon";

const experienceData = [
  {
    id: 1,
    role: "Front-End Developer",
    company: "Coding First.",
    location: "DHA,Bwp",
    period: "Jan 2026 – Present",
    type: "Full-time",
    logo: "Building2",
    color: "#7C6AF7",
    description: "Front-End Developer with a strong coding-first approach, specializing in React.js,Angular, JavaScript,TypeScript and Tailwind CSS to build responsive, high-performance, and user-focused web applications..",
    achievements: [
      "Built high-performance, responsive web apps with React.js, Angular, and Tailwind CSS.",
      "Integrated REST APIs and Firebase backend services for real-time data handling and authentication",
      "Optimized website loading speed using lazy loading and component optimization techniques",
      "Collaborated using Git & GitHub in a team environment, maintaining clean version control workflows",
      "Converted Figma design mockups into pixel-perfect, fully responsive UI components",
      "Improved UI consistency by creating reusable React components and modular CSS structure",
      "Fixed critical UI bugs and enhanced cross-browser compatibility across modern browsers"
    ],
    tech: ["React js", "TypeScript", "JavaScript", "Angular", "Rest Apis", "Tailwind Css"],
  },
  {
    id: 2,
    role: "Front-End Developer",
    company: "CodeAlpha",
    location: "Remote",
    period: "Jun 2024 – Dec 2024",
    type: "Full-time",
    logo: "Palette",
    color: "#A78BFA",
    description: "Worked as a Front-End Developer Intern at CodeAlpha, building responsive web interfaces using React.js, JavaScript, and Tailwind CSS.",
    achievements: [
      "Delivered 12 responsive web projects with React.js, HTML, CSS & JS, achieving 100% client satisfaction",
      "Built reusable React components and modular CSS used across projects",
      "Optimized website performance and Core Web Vitals scores to 95+",
      "Mentored 2 junior developers on front-end best practices"
    ],
    tech: ["React", "JavaScript", "Tailwind CSS", "Figma", "Html5", "Css3", "REST APIs"],
  },
  {
    id: 3,
    role: "Front-End Developer (React.js)",
    company: "Startup Solveit Technologies",
    location: "Lahore, Pakistan",
    period: "Aug 2025 – Dec 2025",
    type: "Full-time",
    logo: "Rocket",
    color: "#22C55E",
    description: "Collaborated on a B2B SaaS product with a teammate, focusing on React.js front-end features in an agile team.",
    achievements: [
      "Built 20+ React components from Figma designs with pixel-perfect accuracy",
      "Reduced page load time by 25% using code splitting and lazy loading",
      "Integrated front-end features seamlessly with back-end APIs",
      "Collaborated closely with teammate to deliver project milestones on schedule",
    ],
    tech: ["React", "JavaScript", "Tailwind CSS", "Redux", "Figma"],
  },
  {
    id: 4,
    role: "Front-End Developer (Freelance)",
    company: "Fiverr",
    location: "Remote",
    period: "2026",
    type: "Freelance",
    logo: "Star",
    color: "#F59E0B",
    description: "Started freelance front-end development projects, delivering responsive websites and web apps using React.js, Angular, and Tailwind CSS.",
    achievements: [
      "Delivered 10+ client projects with fully responsive UI and pixel-perfect designs",
      "Built reusable React and Angular components to accelerate project delivery",
      "Integrated APIs and optimized website performance across projects",
      "Maintained 100% on-time delivery rate with positive client feedback",
    ],
    tech: ["React", "Angular", "JavaScript", "Tailwind CSS", "HTML5", "CSS3", "Firebase"],
  },
];

export default function ExperienceSection() {
  const [expanded, setExpanded] = useState(1);

  return (
    <div  id="experience"  className="py-16 md:py-20" style={{ background: "var(--color-background)" }}>
      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-xs font-semibold tracking-widest uppercase mb-2" style={{ color: "var(--color-primary)", fontFamily: "var(--font-caption)" }}>
            Career Journey
          </p>
          <h2 className="text-3xl md:text-4xl font-bold" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>
            Experience
          </h2>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical line */}
          <div
            className="absolute left-6 md:left-8 top-0 bottom-0 w-px hidden sm:block"
            style={{ background: "linear-gradient(to bottom, transparent, var(--color-border) 10%, var(--color-border) 90%, transparent)" }}
          />

          <div className="space-y-4">
            {experienceData?.map((exp) => (
              <div key={exp?.id} className="relative flex gap-4 md:gap-6">
                {/* Timeline dot */}
                <div className="hidden sm:flex flex-col items-center flex-shrink-0" style={{ width: "64px" }}>
                  <div
                    className="w-12 h-12 rounded-xl flex items-center justify-center z-10 border-2 flex-shrink-0 transition-all duration-200"
                    style={{
                      background: expanded === exp?.id ? `${exp?.color}18` : "var(--color-card)",
                      borderColor: expanded === exp?.id ? exp?.color : "var(--color-border)",
                      boxShadow: expanded === exp?.id ? `0 0 16px ${exp?.color}30` : "none",
                    }}
                  >
                    <Icon name={exp?.logo} size={20} color={exp?.color} />
                  </div>
                </div>

                {/* Card */}
                <div
                  className="flex-1 min-w-0 rounded-xl border overflow-hidden transition-all duration-200 cursor-pointer"
                  style={{
                    background: "var(--color-card)",
                    borderColor: expanded === exp?.id ? exp?.color : "var(--color-border)",
                    boxShadow: expanded === exp?.id ? `0 0 20px ${exp?.color}15` : "none",
                  }}
                  onClick={() => setExpanded(expanded === exp?.id ? null : exp?.id)}
                >
                  <div className="p-4 md:p-5">
                    <div className="flex items-start justify-between gap-3">
                      <div className="flex-1 min-w-0">
                        <div className="flex flex-wrap items-center gap-2 mb-1">
                          <h3 className="text-base font-bold" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>
                            {exp?.role}
                          </h3>
                          <span
                            className="px-2 py-0.5 text-xs rounded-full"
                            style={{ background: `${exp?.color}18`, color: exp?.color, fontFamily: "var(--font-caption)" }}
                          >
                            {exp?.type}
                          </span>
                        </div>
                        <div className="flex flex-wrap gap-3 text-sm" style={{ color: "var(--color-muted-foreground)" }}>
                          <span className="font-medium" style={{ color: exp?.color }}>{exp?.company}</span>
                          <span className="flex items-center gap-1">
                            <Icon name="MapPin" size={12} color="var(--color-muted-foreground)" />
                            {exp?.location}
                          </span>
                          <span className="flex items-center gap-1">
                            <Icon name="Calendar" size={12} color="var(--color-muted-foreground)" />
                            {exp?.period}
                          </span>
                        </div>
                      </div>
                      <Icon
                        name={expanded === exp?.id ? "ChevronUp" : "ChevronDown"}
                        size={18}
                        color="var(--color-muted-foreground)"
                      />
                    </div>

                    {expanded === exp?.id && (
                      <div className="mt-4 pt-4 border-t" style={{ borderColor: "var(--color-border)" }}>
                        <p className="text-sm mb-4 leading-relaxed" style={{ color: "var(--color-muted-foreground)" }}>
                          {exp?.description}
                        </p>
                        <ul className="space-y-2 mb-4">
                          {exp?.achievements?.map((a, i) => (
                            <li key={i} className="flex items-start gap-2 text-sm" style={{ color: "var(--color-foreground)" }}>
                              <Icon name="CheckCircle" size={14} color={exp?.color} className="mt-0.5 flex-shrink-0" />
                              {a}
                            </li>
                          ))}
                        </ul>
                        <div className="flex flex-wrap gap-1.5">
                          {exp?.tech?.map((t) => (
                            <span
                              key={t}
                              className="px-2 py-0.5 text-xs rounded-full border"
                              style={{ fontFamily: "var(--font-caption)", background: "var(--color-muted)", color: "var(--color-foreground)", borderColor: "var(--color-border)" }}
                            >
                              {t}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}